import ZRadioButton from '../radio/radio-button.vue'

ZRadioButton.install = function(app) {
  app.component(ZRadioButton.name, ZRadioButton)
}

export default ZRadioButton